import invoiceService from "./axiosInstances/invoiceService";

export const getInvoiceBySubTxnId = (subTxnId) => {
  return invoiceService.get(`/invoice/v1/download/${subTxnId}`);
};
